<template>
  <div class="page">
    <div class="layout">
      <el-row>
        <el-col :span="24">
          <el-page-header @back="onBack" title="" content="設定 - 年級訂閱價格">
          </el-page-header>
        </el-col>
      </el-row>
      <div class="page-box">
        <el-table
          @sort-change="handleSortChange"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column label="#" type="index" align="center">
          </el-table-column>
          <el-table-column prop="name" label="年級" align="center">
          </el-table-column>
          <el-table-column prop="price" label="訂閱價格" align="center">
          </el-table-column>
          <el-table-column prop="payedAt" label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button
                type="text"
                size="medium"
                @click="onEdit(row.name, row.id, row.price)"
                >編輯</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
      <div style="margin-bottom: 16px;">{{ title }}</div>
      <el-input v-model="price" placeholder=""></el-input>
      <div class="page-button">
        <el-button type="info" @click="onConfirm">確定</el-button>
        <el-button type="success" @click="onCancel">取消</el-button>
      </div>
    </dialogSlotVisible>
  </div>
</template>

<script>
import dialogSlotVisible from "@/components/dialogSlotVisible";
import { getGrades, editGrades } from "@/api/setting";
export default {
  components: { dialogSlotVisible },
  data() {
    return {
      title: "",
      input: "",
      price: "",
      itemId: 0,
      tableData: [],
      tableLabels: [
        {
          label: "付款編號",
          prop: "payId",
        },
        {
          label: "訂單編號",
          prop: "orderNo",
        },
        {
          label: "支付金額",
          prop: "price",
        },
        {
          label: "支付類型",
          prop: "payType",
        },
        {
          label: "付款帳號",
          prop: "payAccount",
        },
        {
          label: "付款時間",
          prop: "payedAt",
        },
      ],
      centerDialogVisible: false,
      form: {
        date: [],
        orderBy: null,
      },
    };
  },
  created() {
    this.getGrades();
  },
  methods: {
    onConfirm() {
      this.editGrades();
    },
    onCancel() {
      this.centerDialogVisible = false;
    },
    onEdit(title, id, price) {
      this.price = price;
      this.title = title;
      this.itemId = id;
      this.centerDialogVisible = true;
    },
    handleSortChange(column) {
      if (column.order === "descending") {
        this.form.orderBy = this.underline(column.column.sortBy) + " desc";
      } else if (column.order === "ascending") {
        this.form.orderBy = this.underline(column.column.sortBy) + " asc";
      } else {
        this.form.orderBy = null;
      }
      this.getGrades();
    },
    onSearch() {
      this.getGrades();
    },
    editGrades() {
      let from = {
        name: this.title,
        price: this.price,
      };
      editGrades(this.itemId, from)
        .then(() => {
          this.getGrades();
        })
        .finally(() => {
          this.centerDialogVisible = false;
        });
    },
    getGrades() {
      let from = {
        startDateGt: this.form.date ? this.form.date[0] : null,
        endDateLt: this.form.date ? this.form.date[1] : null,
        orderBy: this.form.orderBy,
      };
      getGrades(from).then((v) => {
        this.tableData = v.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  .layout {
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }

      .title {
        font-size: 30px;
      }
    }

    .el-button--text {
      color: #166ea5;
      font-size: 16px;
    }
  }
}
.page-box {
  background-color: #fff;
  margin-top: 20px;
  .el-row {
    padding: 20px;
  }
}
</style>